import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap min-h-screen" }
const _hoisted_2 = { class: "flex flex-col w-full items-start pt-4 border-t border-gray-200 gap-4 px-6" }
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_4 = { class: "flex flex-wrap w-full" }
const _hoisted_5 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdvancedProgramSettings = _resolveComponent("AdvancedProgramSettings")!
  const _component_ComingSoonFeatures = _resolveComponent("ComingSoonFeatures")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple" }, null, -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showAdvancedSettings && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_AdvancedProgramSettings, {
              key: 0,
              programId: _ctx.userStore.selectedProgram?.id || '',
              initialPayoutOnlyCallDurationMoreThan5: 
            _ctx.payoutOnlyCallDurationMoreThan5
          ,
              initialExpertTags: _ctx.initialExpertTags,
              onProgramUpdated: _ctx.refetchProgramDetails
            }, null, 8, ["programId", "initialPayoutOnlyCallDurationMoreThan5", "initialExpertTags", "onProgramUpdated"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ComingSoonFeatures)
      ])
    ])
  ]))
}